import {
  createRoute,
  lazyRouteComponent,
  redirect,
} from "@tanstack/react-router";

import { plantDetailLayoutRoute } from "./route";

import { NestedRouteErrorComponent } from "@/components/organisms/ErrorBoundary/NestedRouteErrorComponent";
import { trackAlertsEmailClicked } from "@/config/mixpanel";
import { validateEmailLinkSearch } from "@/routes/emailLinkSearch";

/* eslint-disable @typescript-eslint/only-throw-error */

export const plantDashboardRoute = createRoute({
  path: "dashboard",
  getParentRoute: () => plantDetailLayoutRoute,
  validateSearch: validateEmailLinkSearch,
  beforeLoad: ({ search, location }) => {
    if (search.source === "email" && search.cta === "diagnose") {
      trackAlertsEmailClicked("diagnose");
      throw redirect({ href: location.pathname, replace: true });
    }
  },
  component: lazyRouteComponent(async () => {
    const m = await import("./DashboardPage/DashboardPage");
    return { default: m.DashboardPage };
  }),
  errorComponent: NestedRouteErrorComponent,
});
